import React, { ReactElement } from 'react';

import { FieldList, FieldListAPI, Link } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { trigger } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: FieldListAPI })
export default class HpmsCustomListField extends FieldList {

  renderRemove(index: number): ReactElement | null {
    const { readOnly, removeFieldExpression } = this.props;

    if (readOnly) {
      return null;
    }

    return (
      <Link className="c-field-list__remove" onClick={trigger(this.onRemove, index)} value={removeFieldExpression} />
    );
  }

  render(): ReactElement {
    const { value } = this.props;

    return (
      <div className={this.getClassName()}>
        {value.map((row, index) => this.renderRow(row, index))}
      </div>
    );
  }

}
